export const UserCategoriesEnum = {
  CLIENT: 'CLIENTE',
  MANAGER: 'GESTORES',
  ENTREPRENEUR: 'EMPREENDIMENTO',
};
